import {SportstypeSpec} from "../types";
import start from "../../icons/floorball/start";
import end from "../../icons/floorball/end";
import bully from "../../icons/floorball/bully";
import timeout from "../../icons/floorball/timeout";
import injury from "../../icons/floorball/injury";
import goal from "../../icons/floorball/goal";
import redCard from "../../icons/floorball/red-card";
import suspensionTwo from "../../icons/floorball/suspension-two";
import suspensionFive from "../../icons/floorball/suspension-five";
import suspensionTwoPlusTen from "../../icons/floorball/suspension-two-plus-ten";
import penalty from "../../icons/floorball/penalty";
import main from "../../icons/floorball/main";

const floorball: SportstypeSpec = {
  id: 'floorball',
  svg: main,
  releaseStage: 'alpha',
  phases: ['pregame', 'periods', 'postgame'],
  events: [
    {
      id: 'start',
      important: true,
      svg: start
    },
    {
      id: 'end',
      important: true,
      svg: end
    },
    {
      id: 'bully',
      important: true,
      svg: bully
    },
    {
      id: 'timeout',
      important: true,
      svg: timeout
    },
    {
      id: 'injury',
      important: true,
      svg: injury,
      team: 'any',
      players: [
        {id: "injured"}
      ]
    },
    {
      id: 'goal',
      important: true,
      svg: goal,
      team: 'any',
      players: [
        {id: 'scorer'}
      ]
    },
    {
      id: 'red-card',
      important: true,
      svg: redCard,
      team: 'any',
      players: [
        {id: 'offender'}
      ]
    },
    {
      id: 'suspension-two',
      important: true,
      svg: suspensionTwo,
      team: 'any',
      players: [
        {id: 'offender'}
      ]
    },
    {
      id: 'suspension-five',
      important: true,
      svg: suspensionFive,
      team: 'any',
      players: [
        {id: 'offender'}
      ]
    },
    {
      id: 'suspension-two-plus-ten',
      important: true,
      svg: suspensionTwoPlusTen,
      team: 'any',
      players: [
        {id: 'offender'}
      ]
    },
    {
      id: 'penalty',
      important: true,
      svg: penalty,
      team: 'any',
      players: [
        {id: 'shooter'},
        {
          id: 'keeper',
          from: 'other-team'
        }
      ]
    }
  ]
}

export default floorball
